import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(rest)/films/[slug]/components/FilmTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[festival-slug]/[locale]/(rest)/films/[slug]/components/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(rest)/films/[slug]/components/ScreeningList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/blocks/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/RunningLineBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AddToCartButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AddToMyScheduleButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Link.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/i18n/navigation.tsx");
